import React from 'react';
import { useTranslation } from 'react-i18next';
import { TodoListItem } from '@unmind/design-system';
import { useWelcomeModalReopen, WelcomeModal } from 'Home/WelcomeModal';
import { useTodoListItemTracking } from 'Home/PersonalisedToday/hooks/useTodoListItemTracking';
import { SkeletonItem } from './SkeletonItem';

/**
 * Reopens the welcome modal during a member's first 14 days. It is never
 * completed — the member can come back to it as often as they need.
 */
export const SupportFinderItem = () => {
  const { t: translate } = useTranslation('homepage', {
    keyPrefix: 'todo_list_section.support_finder_item',
  });
  const {
    canReopen,
    isLoading,
    isOpen,
    open,
    close,
    firstName,
    options,
    practicalSupport,
  } = useWelcomeModalReopen();
  const { trackClicked } = useTodoListItemTracking('support-finder', {
    shown: canReopen && !isLoading,
    completed: false,
  });

  // A background refetch must not swap the row for a skeleton and unmount the
  // modal while the member is using it.
  if (!isOpen) {
    if (isLoading) {
      return <SkeletonItem />;
    }

    if (!canReopen) {
      return null;
    }
  }

  return (
    <>
      <TodoListItem
        title={translate('title')}
        description={translate('description')}
        cta={translate('cta')}
        thumbnail={{ icon: 'support-finder', tone: 'accent' }}
        onClick={() => {
          trackClicked();
          open();
        }}
      />
      {isOpen && (
        <WelcomeModal
          open
          entryPoint="checklist"
          options={options}
          firstName={firstName}
          practicalSupport={practicalSupport}
          onComplete={close}
          onDismiss={close}
        />
      )}
    </>
  );
};
